import { render, staticRenderFns } from "./CompanyCrud.vue?vue&type=template&id=6a5d462e"
import script from "./CompanyCrud.vue?vue&type=script&lang=js"
export * from "./CompanyCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports